/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CategoryGroupDto } from './categoryGroupDto';


export interface CompositionGroupDto { 
    id?: number | null;
    limit?: number;
    name?: string | null;
    categoryGroups?: Array<CategoryGroupDto> | null;
}

